(function (root, factory) {
    if (typeof exports === 'object' && typeof exports.nodeName !== 'string') {
        factory(exports);
    } else {
        factory((root.cianMetrics = {}));
    }
}(this, function (exports) {
  var additionalMetrics = [];

  function getBrowserTimings() {
    try {
      return Object.keys(Object.getPrototypeOf(window.performance.timing))
        .map(function(key) { return [key, window.performance.timing[key]]; })
        .filter(function (item) { return typeof item[1] === 'number' && item[1] > 0; });
    } catch(e) {
      return [];
    }
  }

  function collectMetrics(additionalMetrics) {
    try {
      var browserTimings = getBrowserTimings();

      if (browserTimings.length === 0) return [];

      var navigationStart = browserTimings.filter(function(item) {
        return item[0] === 'navigationStart';
      }).shift();

      if (!navigationStart) return [];

      return browserTimings
        .filter(function(item) { return item[0] !== 'navigationStart' || item[1] > 0 })
        .concat(additionalMetrics)
        .sort(function (itemA, itemB) { return itemA[1] - itemB[1]; })
        .map(function(item) { return [item[0], item[1] - navigationStart[1]] });
    } catch(e) {
      return [];
    }
  }

  exports.add = function(suffix) {
    additionalMetrics.push([suffix, Date.now()]);
  };

  exports.collect = function(prefix) {
    return collectMetrics(additionalMetrics)
      .map(function(item) {
        return {
          name: [prefix, item[0]].join('.'),
          type: 'timer',
          value: item[1],
        };
      });
  };

  exports.send = function(metrics) {
    if (metrics.length === 0) return;

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/ajax/stats/', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify(metrics));
  };

  exports.waitForAllBrowserMetrics = function(cb) {
    if (document.readyState === 'complete') {
      setTimeout(cb, 1000);
    } else {
      window.addEventListener('load', function() {
        setTimeout(cb, 1000);
      });
    }
  };

  exports.collectAndSend = function(prefix) {
    exports.waitForAllBrowserMetrics(function() {
      exports.send(exports.collect(prefix));
    });
  }
}));



//////////////////
// WEBPACK FOOTER
// ./~/@cian/metrics/index.js
// module id = 377
// module chunks = 0